import { gql } from "@apollo/client";

export const SEND_MAIL = gql`
 mutation SendMail($input:ailInput) {
    sendMail(input: $input) {
        data {
            message
        }
        error {
            code
            field
            message
        }
    }
}

`;

